import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import * as $ from 'jquery';
import * as AOS from 'aos';


@Component({
  selector: 'app-operacion-computos',
  templateUrl: './operacion-computos.component.html',
  styleUrls: ['./operacion-computos.component.css']
})
export class OperacionComputosComponent implements OnInit {
  constructor(private titleService: Title) { }

  ngOnInit() {

    AOS.init({
      duration: 500,
      easing: 'linear',
    });

    // $(document).ready(function(){
    //   $(".subrayado").removeClass("subrayado");
    //   $("#Operacioncomputos").addClass("subrayado");
    //   $('.active-INE').removeClass('active-INE');
    //   $(".subrayado").closest('.nav-item').find("a").addClass('active-INE');
    //   $("#main").removeClass("m-main-menu");
    // });
    this.titleService.setTitle('Operación de cómputos | CentroAyuda Cómputos');
  }

}



// WEBPACK FOOTER //
// ./src/app/components/conoce-computos/operacion-computos/operacion-computos.component.ts